<template>
  <div>
    <Modal
      v-model="jobmodal"
      :title="$t('Adding_Vacancies')"
      @on-cancel="canceljob"
      :mask-closable="false"
      ><!-- 追加空岗 -->
      <Form :model="jobFormItem" :label-width="140" label-position="right">
        <!-- 空岗是否顶层 -->
        <!-- <FormItem :label="$t('Be_People_Manager')">
                <Select v-model="jobFormItem.beTopLevel" style="width:200px" placeholder="" @on-change="jobChange">
                    <Option v-for="item in yesOrNo" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                </Select>
                <Button v-if="jobFormItem.beTopLevel=='1'" @click="addPerson(1)">选择下属</Button>
                </FormItem> -->

        <FormTitle
          :titleText="$t('PB_Vacancies_Information')"
        /><!-- 空岗信息 -->
        <FormItem :label="$t('PB_Vacancies_Position')"
          ><!-- 空岗职位 -->
          <!-- <Input style="width:200px" type="text" v-model="jobFormItem.jobName" /> -->
          <Input
            v-model="jobFormItem.jobName"
            search
            readonly
            @on-search="(pageInfo.pageNo = 1), searchPos(0)"
            style="width:200px"
          />
        </FormItem>
        <FormItem label="Band">
          <Select v-model="jobFormItem.hcmBand" style="width:200px" clearable>
            <Option
              v-for="item in Band"
              :value="item.ch_value"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem :label="$t('Position_Title_Chinese')"
          ><!-- 职务描述（中文） -->
          <Input
            style="width:200px"
            type="text"
            v-model="jobFormItem.positionCTitle"
          />
        </FormItem>
        <FormItem :label="$t('Position_Title_English')"
          ><!-- 职务描述（英文） -->
          <Input
            style="width:200px"
            type="text"
            v-model="jobFormItem.positionETitle"
          />
        </FormItem>
          <FormItem :label="$t('StrategicPosition')">
              <Checkbox
              true-value="1"
              false-value="0"
              v-model="jobFormItem.keyPosition"
            />
          </FormItem>
        <FormTitle
          :titleText="$t('PB_Line_Manager_Information')"
        /><!-- 汇报人信息 -->
        <FormItem :label="$t('PB_Line_Manager')"
          ><!-- 汇报人 -->
          <Input
            style="width:200px"
            type="text"
            v-model="jobFormItem.reportName"
            search
            @on-search="searchUser"
          />
        </FormItem>
        <FormItem :label="$t('BU')"
          ><!-- 业务单元 -->
          <Select
            :disabled="
              jobFormItem.beTopLevel == '0' || !jobFormItem.beTopLevel
                ? true
                : false
            "
            clearable
            v-model="jobFormItem.businessUnit"
            style="width:200px"
            placeholder=""
          >
            <Option
              v-for="item in businessUnitList"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem :label="$t('Department')"
          ><!-- 大区 -->
          <Select
            :disabled="
              jobFormItem.beTopLevel == '0' || !jobFormItem.beTopLevel
                ? true
                : false
            "
            clearable
            v-model="jobFormItem.department"
            style="width:200px"
            placeholder=""
          >
            <Option
              v-for="item in departmentList"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem :label="$t('Funciton')"
          ><!-- 职能 -->
          <Select
            :disabled="
              jobFormItem.beTopLevel == '0' || !jobFormItem.beTopLevel
                ? true
                : false
            "
            clearable
            v-model="jobFormItem.postFun"
            style="width:200px"
            placeholder=""
          >
            <Option
              v-for="item in functionList"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="职位"
          ><!-- 职位 -->
          <!-- <Select :disabled="jobFormItem.beTopLevel=='0'?true:false" v-model="jobFormItem.position" style="width:200px" placeholder="">
                    <Option  v-for="item in positionList" :value="item.code" :key="item.code">{{ item.ch_value }}</Option>
                </Select> -->
          <Input
            v-model="jobFormItem.positionCodeName"
            search
            @on-search="searchPos(1)"
            style="width:200px"
            :disabled="
              jobFormItem.beTopLevel == '0' || !jobFormItem.beTopLevel
                ? true
                : false
            "
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="savejob" :disabled="spinloading"
          ><!-- 确认 -->{{ $t("Confirm") }}</Button
        >
        <Button type="text" @click="canceljob" :disabled="spinloading"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
      </div>
    </Modal>
    <selectPeople ref="selectPeople" @onSelect="onSelect"></selectPeople>
    <PDselectPeople
      ref="PDselectPeople"
      @onSelectList="onSelectList"
    ></PDselectPeople>
    <Modal v-model="posModal" :title="$t('PB_Select')" width="80%"
      ><!-- 选择职位 -->
      <Form :model="modalFormItem" label-position="left">
        <Row :gutter="20">
          <Col :xs="24" :sm="24" :md="12" :lg="5">
            <FormItem :label="$t('Name')" :label-width="60"
              ><!-- 姓名 -->
              <Input type="text" v-model="modalFormItem.userName" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="5">
            <FormItem :label="$t('Employee_Code')" :label-width="80"
              ><!-- 员工号 -->
              <Input type="text" v-model="modalFormItem.empCode" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="5">
            <FormItem :label="$t('Position_ID')" :label-width="90"
              ><!-- 职位Code -->
              <Input type="text" v-model="modalFormItem.position" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="5">
            <FormItem :label="$t('Plan_Position_Name')" :label-width="100"
              ><!-- 职位英文 -->
              <Input type="text" v-model="modalFormItem.positionETitle" />
            </FormItem>
          </Col>
          <Col :xs="24" :sm="24" :md="12" :lg="4">
            <Button @click="(pageInfo.pageNo = 1), getPosData()"
              ><!-- 检 索 -->{{ $t("Search") }}</Button
            >
            <Button @click="handleReset()"
              ><!-- 清空检索 -->{{ $t("PB_Clear") }}</Button
            >
          </Col>
        </Row>
      </Form>
      <Table
        border
        :columns="modelColumns"
        :data="modelData"
        ref="selectiona"
        :loading="loading"
      >
        <template slot="action" slot-scope="{ row, index }">
          <Icon
            size="26"
            color="#006B37"
            type="md-menu"
            @click="onSelectPos(row, index)"
          />
        </template>
      </Table>
      <div style="display: flex;justify-content: end;margin-top: 30px;">
        <Page
          :total="total"
          :current="pageInfo.pageNo"
          @on-change="pageChange"
        ></Page>
      </div>
      <div slot="footer">
        <Button type="text" @click="posModal = false"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
      </div>
    </Modal>
    <Modal v-model="sessionModal" title="已添加的空岗" width="50%">
      <Table
        border
        size="small"
        :columns="modalColumns"
        :loading="sessionLoading"
        :data="sessionData"
        style="margin:20px 0"
      ></Table>
      <div slot="footer">
        <Button @click="sessionModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import PDselectPeople from "./PDselectPeopleEmp";
import selectPeople from "../components/selectPeople";
export default {
  components: { selectPeople, PDselectPeople },
  data() {
    return {
      jobmodal: false,
      jobFormItem: {
        beTopLevel: "0",
        reportName: "",
        reportSerialnumber: "",
        businessUnit: "",
        department: "",
        position: "",
        postFun: "",
        positionCodeName: "",
        jobName: "",
        nullJobPosition: "",
        nullJobSerialnumberList: []
      },
      yesOrNo: [],
      businessUnitList: [],
      departmentList: [],
      functionList: [],
      Band: [],
      nullJobSerialnumberList: [],
      tIndex: "",
      nullJobNum: 0,
      id: "",
      edit: false,
      modelData: [],
      loading: false,
      posModal: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      modalFormItem: {},
      modalIndex: "",
      sessionLoading: false,
      sessionModal: false,
      sessionData: [],
      item: {},
      spinloading: false
    };
  },
  computed: {
    modelColumns() {
      return [
        {
          title: this.$t("Select_Dev") /* 选择 */,
          slot: "action",
          minWidth: 80,
          align: "center"
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Position_ID") /* 职位Code */,
          key: "position",
          align: "center",
          minWidth: 200
        },
        {
          title: this.$t("Plan_Position_Name") /* 职位英文 */,
          key: "positionEngTitle",
          align: "center",
          minWidth: 300
        }
      ];
    },
    modalColumns() {
      return [
        {
          title: "类型",
          key: "userType",
          align: "center",
          minWidth: 100
        },
        {
          title: "姓名",
          key: "userName",
          align: "center",
          minWidth: 260
        },
        {
          title: this.$t("Meeting_Subjects") /* 会议名称 */,
          key: "meetingName",
          align: "center",
          minWidth: 200
        }
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  mounted() {
    this.getListData();
  },
  methods: {
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.yesOrNo = res.YesOrNo;
          this.businessUnitList = res.businessUnitList;
          this.departmentList = res.departmentList;
          this.functionList = res.functionList;
          this.Band = res.Band;
        }
      });
    },
    getPosData() {
      this.loading = true;
      axios
        .post("/AchPeopleBoard/selectPositionCodeList", {
          ...this.pageInfo,
          ...this.modalFormItem
        })
        .then(res => {
          this.loading = false;
          if (res) {
            this.modelData = res.data;
            this.total = parseInt(res.pageInfo.total);
          }
        });
    },
    savejob() {
      if (!this.jobFormItem.jobName) {
        this.jobmodal = true;
        this.$Message.error(this.$t("Emp_Ach_mess20")); //选择空岗职位
        return;
      }
      if (!this.jobFormItem.reportName) {
        this.jobmodal = true;
        this.$Message.error(this.$t("Emp_Ach_mess21")); //选择汇报人
        return;
      }
      // this.jobmodal=false
      // if(this.edit){
      //     this.$emit('jobEdit',this.jobFormItem)
      // }else {
      //     this.$emit('jobSave',this.jobFormItem)
      // }
      // this.$nextTick(() => {
      //      this.jobFormItem={}
      //     this.nullJobSerialnumberList=[]
      //     this.jobmodal=false
      // })
      let obj = {
        meetingId: this.id,
        ...this.jobFormItem,
        nullJobSerialnumberList: this.jobFormItem.nullJobSerialnumberList,
        successorSerialnumberList: [],
        successorLevel: "",
        beNullJob: 1,
        dirSupPosition: ""
      };
      this.spinloading = true;
      axios.post("/successorInfo/insertSuccessionInfo", obj).then(res => {
        this.spinloading = false;
        if (res != null && res.length > 0) {
          this.sessionModal = true;
          this.getSessionData(this.jobFormItem);
        }else if(res.errorMessage) {

        }else {
          this.$Message.success(this.$t("Save_Successful"));
          // this.getData(this.id)
          this.jobFormItem = {
            reportName: "",
            businessUnit: "",
            department: "",
            position: "",
            postFun: "",
            positionCodeName: "",
            jobName: "",
            nullJobPosition: "",
            reportSerialnumber: "",
            nullJobSerialnumberList: [],
            beTopLevel: "0"
          };
          this.nullJobSerialnumberList = [];
          this.jobmodal = false;
          this.$emit("jobSave");
        }
       
      });
    },
    getSessionData(row) {
      this.item = JSON.parse(JSON.stringify(row));
      let obj = JSON.parse(JSON.stringify(row));
      this.sessionLoading = true;
      axios.post("/successorInfo/selectCheckInfo", { ...obj }).then(res => {
        this.sessionLoading = false;
        if (res) {
          this.sessionData = res;
        }
      });
    },
    searchUser() {
      this.$refs.selectPeople.modal = true;
      this.$refs.selectPeople.modelColumns.splice(-1, 1);
      this.$refs.selectPeople.modelColumns.unshift({
        title: this.$t("PB_Select_Search") /* 选择 */,
        slot: "action1",
        minWidth: 60,
        align: "center"
      });
    },
    onSelect(item) {
      this.jobFormItem.reportSerialnumber = item.serialnumber;
      this.jobFormItem.reportName = item.userName;
      this.jobFormItem.businessUnit = item.businessUnitCode;
      this.jobFormItem.department = item.departmentCode;
      this.jobFormItem.position = item.positionCode;
      this.jobFormItem.positionCodeName = item.positionCodeName;
      this.jobFormItem.postFun = item.postFunCode;
    },
    canceljob() {
      this.jobmodal = false;
      this.jobFormItem = {
        reportName: "",
        businessUnit: "",
        department: "",
        position: "",
        postFun: "",
        positionCodeName: "",
        jobName: "",
        nullJobPosition: "",
        reportSerialnumber: "",
        beTopLevel: "0",
        nullJobSerialnumberList: []
      };
    },
    jobChange() {
      this.jobFormItem.reportName = "";
      this.jobFormItem.businessUnit = "";
      this.jobFormItem.department = "";
      this.jobFormItem.position = "";
      this.jobFormItem.postFun = "";
      this.jobFormItem.positionCodeName = "";
      this.jobFormItem.jobName = "";
      this.jobFormItem.nullJobPosition = "";
      this.jobFormItem.reportSerialnumber = "";
      this.jobFormItem.beTopLevel = "0";
    },
    addPerson(val) {
      this.$refs.PDselectPeople.selectList = [
        ...this.jobFormItem.nullJobSerialnumberList
      ];
      this.$refs.PDselectPeople.userType = this.userType;
      this.$refs.PDselectPeople.id = this.id;
      this.$refs.PDselectPeople.jobId = this.jobFormItem.jobId;
      this.$refs.PDselectPeople.getData();
      this.$refs.PDselectPeople.modal = true;

      // this.$refs.peoModal.rowItem=this.rowItem
      // this.$refs.ispeoModal.targetkey=key
    },
    onSelectList(list) {
      this.jobFormItem.nullJobSerialnumberList = list;
    },
    onSelectPos(row, index) {
      if (this.modalIndex == 0) {
        this.jobFormItem.jobName = row.positionETitle;
        this.jobFormItem.nullJobPosition = row.position;
      } else if (this.modalIndex == 1) {
        this.jobFormItem.positionCodeName = row.positionETitle;
        this.jobFormItem.position = row.position;
      }
      this.posModal = false;
    },
    searchUser() {
      this.$refs.selectPeople.modal = true;
      this.$refs.selectPeople.modelColumns.splice(-1, 1);
      this.$refs.selectPeople.modelColumns.unshift({
        title: this.$t("PB_Select_Search") /* 选择 */,
        slot: "action1",
        minWidth: 60,
        align: "center"
      });
    },
    searchPos(val) {
      this.modalIndex = val;
      this.posModal = true;
      this.getPosData();
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getPosData();
    },
    handleReset() {
      this.modalFormItem = {};
      // this.pageInfo.pageNo=1
      // this.getPosData()
    }
  }
};
</script>

<style lang="less" scoped>
.formTitleBox {
  height: 32px !important;
  line-height: 32px !important;
  box-shadow: 0 5px 10px #cccccc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PeopleBoardComponents/JobModal.vue